import { useWrappedRecoilValue } from '../../hooks/useWrappedRecoilValue'
import { channelsSelector } from '../channels/channels.selectors'

export const useFetchChannels = (ids: string[]) => {
  return useWrappedRecoilValue(channelsSelector(ids))
}
